(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-category-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DRAG_THRESHOLD = 7; // px of movement before a press counts as a drag (click-vs-drag)

    function initTrack(track) {
      if (!track || track.dataset.lmDragBound === '1') return; // double-bind guard (editor reloads)
      track.dataset.lmDragBound = '1';

      var isDown = false;
      var dragged = false;
      var captured = false;
      var startX = 0;
      var startScroll = 0;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return; // leave touch to the native swipe
        if (track.scrollWidth <= track.clientWidth) return; // nothing to scroll -> ignore
        isDown = true;
        dragged = false;
        captured = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        // NB: do NOT setPointerCapture here. Capturing on pointerdown makes the browser
        // retarget the following `click` to the track, so a plain click would never reach
        // the <a> tile and never navigate. We capture only once a real drag begins (below).
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (!dragged && Math.abs(dx) > DRAG_THRESHOLD) {
          // A real drag has started: now grab the pointer so it keeps tracking even if
          // the cursor leaves the track, and show the grabbing affordance.
          dragged = true;
          track.classList.add('is-dragging');
          try {
            track.setPointerCapture(e.pointerId);
            captured = true;
          } catch (err) {}
        }
        if (dragged) track.scrollLeft = startScroll - dx; // 1:1, no momentum
      });

      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        if (captured) {
          captured = false;
          try {
            track.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // CLICK-vs-DRAG GUARD: a drag past the threshold must never navigate the <a> tile.
      // Capture phase beats the link's default; the flag resets so the next real click works.
      track.addEventListener(
        'click',
        function (e) {
          if (!dragged) return; // below threshold -> normal click, link navigates
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        },
        true
      );

      // Kill the native image ghost-drag (Firefox).
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    function updateScrollable() {
      // Toggle the grab affordance: only when the row genuinely overflows.
      var tracks = document.querySelectorAll('.lm-cat__track');
      for (var i = 0; i < tracks.length; i++) {
        tracks[i].classList.toggle('is-scrollable', tracks[i].scrollWidth > tracks[i].clientWidth);
      }
    }

    function initScope(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var tracks = scope.querySelectorAll('.lm-cat__track');
      for (var i = 0; i < tracks.length; i++) initTrack(tracks[i]);
      updateScrollable();
    }

    var ticking = false; // rAF-throttled resize re-measure
    window.addEventListener('resize', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateScrollable();
        ticking = false;
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initScope(document);
      });
    } else {
      initScope(document);
    }

    // Theme editor: (re)bind when a Category strip section is added or reloaded.
    document.addEventListener('shopify:section:load', function (e) {
      initScope(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
